"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Billing = void 0;
var react_1 = __importDefault(require("react"));
var Billing = function (props) { return (react_1.default.createElement("svg", __assign({ viewBox: "0 0 68 68", xmlns: "http://www.w3.org/2000/svg" }, props),
    react_1.default.createElement("path", { opacity: ".3", d: "m55.92 19.476 7.29 40.44-43.245 7.797-9.731-53.976L53.48 5.941l2.44 13.535Z", fill: "currentColor" }),
    react_1.default.createElement("path", { d: "m51.108 37.214-27.73 5 1.012 5.611 27.73-4.999-1.012-5.612ZM49.175 26.485l-27.73 5 1.011 5.612 27.73-5-1.011-5.612ZM38.351 50.592l-13.04 2.35 1.012 5.612 13.04-2.35-1.012-5.612ZM52.534 26.22l2.828-5.111 9.146 3.463L64.679 0 39.573 15.774l8.862 2.834L60.409 6.564 52.123 20.16l.411 6.06Z", fill: "currentColor" }),
    react_1.default.createElement("path", { d: "m37.304 8.855-6.234-4.33L4 9.405l9.73 53.976 5.283-.952-8.779-48.694 27.07-4.88Z", fill: "currentColor" }))); };
exports.Billing = Billing;
